import {Box} from "@chakra-ui/react";
import {Element} from "react-scroll";
import AboutComponent from "../components/about/AboutComponent";
import ValuePropositionComponent from "../components/actor/ValuePropositionComponent";
import actorScreenBg from "../images/actor_image_bg.png";
import actorScreen from "../images/actor_image_front.png";
import producerScreen from "../images/producer_screen_img.png";
import CreatorComponent from "../components/creator/CreatorComponent";
import BottomComponent from "../components/bottom/BottomComponent";
import BackgroundComponent from "../components/backgorund/BackgroundComponent";
import React from "react";
import ValuePropositions from "../data/value_propositions";
import {useTranslation} from "react-i18next";


const LandingPage = () => {
    
    let producerComponentListItems = ValuePropositions.producers
    let actorComponentListItems = ValuePropositions.actors

    const [t, i18n] = useTranslation('common');


    return <Box paddingRight="20px"
                paddingLeft="20px"
                paddingTop="10px"
                className="App-body">
        <Element name='home'>
            <AboutComponent/>
        </Element>
        <Element name='actors'>
            <ValuePropositionComponent content={actorComponentListItems}
                                       image={actorScreenBg}
                                       imageForAnimation={actorScreen}
                                       subTitle={t("Use indie to find your next role")}
                                       title={t("Actors")}
                                       isProducer={true}/>
        </Element>
        <Element name='producers'>
            <ValuePropositionComponent content={producerComponentListItems}
                                       image={producerScreen}
                                       subTitle={t("Use indie to find talent for your next project")}
                                       title={t("For Producers")}
                                       isProducer={false}/>
        </Element>

        <Element name='about'>
            <CreatorComponent/>
        </Element>
        <BottomComponent/>
        <BackgroundComponent/>

    </Box>


}
export default LandingPage